import { render, staticRenderFns } from "./ArmageddonTutorial.vue?vue&type=template&id=faccecf8&"
import script from "./ArmageddonTutorial.vue?vue&type=script&lang=ts&"
export * from "./ArmageddonTutorial.vue?vue&type=script&lang=ts&"
import style0 from "./ArmageddonTutorial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports